import lenis from "../../modules/_lenis";
import fixedCta from "./_fixedCta";
import mvAnimation from "./_mvAnimation";
import splideSetting from "./_splideSetting";
import waveAnimation from "./_waveAnimation";

const pageExpoSummer = (): void => {
  // lenis
  lenis();
  // 波のアニメーション
  waveAnimation();
  // SVGアニメーション
  mvAnimation();
  // splideのセットアップ
  splideSetting();
  // 固定CTAの表示動作
  fixedCta();
};

export default pageExpoSummer;
